module.exports = __webpack_public_path__ + "static/media/2_en.e739765f.png";